import { CURRENT_USER } from '../../constants';
import { getCart } from '../../react-query-hooks/Cart/useGetCartItems';
import { updateCartOrder } from '../../redux/slices/cartSlice';

export const syncCartOnLogin = async (cartDispatch) => {
  const customer_id = JSON.parse(localStorage.getItem(CURRENT_USER)).id;
  const response = await getCart({ customer_id: customer_id });
  if (response && response.items) cartDispatch(updateCartOrder(response));
};
